import { render, staticRenderFns } from "./reserve_keypad_event9.vue?vue&type=template&id=2fb12461&scoped=true&"
import script from "./reserve_keypad_event9.vue?vue&type=script&lang=js&"
export * from "./reserve_keypad_event9.vue?vue&type=script&lang=js&"
import style0 from "./reserve_keypad_event9.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./reserve_keypad_event9.vue?vue&type=style&index=1&id=2fb12461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb12461",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VFlex,VImg,VLayout})
